// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20Nps","fullView":"styles_fullView__20D5Z"};